import { useMutation } from "@noom/hive-core";
import { useCallback } from "react";

import { AdInteractionType } from "gql/graphql";

import { useAuthCredentials } from "../../../../hooks/useAuthCredentials";
import {
  MARKETPLACE_PLACEMENT_GROUP_NAME,
  MarketplaceAd,
} from "../../hooks/useMarketplaceAds";
import { TRACK_AD_INTERACTIONS_MUTATION } from "../../gql";
import { buildRecommendationContextInput } from "../utils";

export type TrackAdInteraction = (
  ad: MarketplaceAd,
  placementName: string,
  interactionType: AdInteractionType
) => void;

/**
 * Fire-and-forget reporter for marketplace ad interactions (impressions,
 * clicks).
 */
export const useTrackAdInteractions = (): TrackAdInteraction => {
  const { accessCode } = useAuthCredentials();
  const [trackAdInteractionsMutation] = useMutation(
    TRACK_AD_INTERACTIONS_MUTATION
  );

  return useCallback(
    (ad, placementName, interactionType) => {
      if (!accessCode) {
        return;
      }

      const interaction = {
        interactionType,
        adName: ad.adName,
        offerName: ad.offerName,
        placementName,
        placementGroupName: MARKETPLACE_PLACEMENT_GROUP_NAME,
        recommendationContext: buildRecommendationContextInput(
          ad.recommendationContext
        ),
        offerEligibilityState: ad.offerEligibilityState,
      };

      trackAdInteractionsMutation({
        variables: { accessCode, interactions: [interaction] },
      }).catch(() => {});
    },
    [accessCode, trackAdInteractionsMutation]
  );
};
